import { Search } from "lucide-react";

/**
 * Univerzální vyhledávací pole nad tabulkou.
 * Volitelné dodatečné filtry se vykreslí napravo (např. select).
 */
export default function SearchBar({ value, onChange, placeholder = "Hledat…", testid = "search", children }) {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#57534E] pointer-events-none" />
        <input
          data-testid={testid}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="input-cafe w-full pl-9"
        />
      </div>
      {children}
    </div>
  );
}

/**
 * Helper: zfiltruje pole objektů podle hledaného textu napříč zadanými klíči (case-insensitive).
 */
export function applyTextFilter(items, query, getStrings) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return items;
  return items.filter((it) => {
    const fields = getStrings(it).filter(Boolean).map((s) => String(s).toLowerCase());
    return fields.some((f) => f.includes(q));
  });
}
